export const contestConstants = {
    CONTEST_SEND_REQUEST: 'CONTEST_SEND_REQUEST',
    CONTEST_SEND_SUCCESS: 'CONTEST_SEND_SUCCESS',
    CONTEST_SEND_FAILURE: 'CONTEST_SEND_FAILURE',

    CONTEST_SENDING_REQUEST: 'CONTEST_SENDING_REQUEST',
    CONTEST_FORM_CLEAR: 'CONTEST_FORM_CLEAR',
    CONTEST_CLEAR_ERROR: 'CONTEST_CLEAR_ERROR',
    CONTEST_CLEAR_STATE: 'CONTEST_CLEAR_STATE',
};